import { checkPermissionsOrRedirect } from '@/helpers/routeMiddleware';
import { startCase } from 'lodash-es';
import ClosedRequisitions from '@/components/requisitions/pages/Closed.vue';
import DraftRequisitions from '@/components/requisitions/pages/Draft.vue';
import OpenRequisitions from '@/components/requisitions/pages/Open.vue';
import RequisitionLibrary from '@/views/RequisitionLibrary.vue';
import RequisitionReport from '@/views/RequisitionReport.vue';

export const requisitions = (authDataStore) => ([
  {
    path: '/requisitions/',
    name: 'requisition-library',
    component: RequisitionLibrary,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['viewRequisitionDocuments']),
    meta: { title: 'Library' },
    children: [
      {
        name: 'draft-requisitions',
        path: 'draft-requisitions',
        component: DraftRequisitions,
        meta: { title: 'Draft Requisitions' },
      },
      {
        name: 'open-requisitions',
        path: 'open-requisitions',
        component: OpenRequisitions,
        meta: { title: 'Open Requisitions' },
      },
      {
        name: 'closed-requisitions',
        path: 'closed-requisitions',
        component: ClosedRequisitions,
        meta: { title: 'Closed Requisitions' },
      },
    ],
  },
  {
    path: '/requisitions/:id',
    name: 'requisition-report',
    component: RequisitionReport,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['viewRequisitionInfo']),
    meta: {
      title: ({ title } = {}) => ((typeof title === 'string')
        ? title
        : ''),
      parentTitle: ({ status } = {}) => (typeof status === 'string' && status ? `${startCase(status)} Reqs` : ''),
    },
  },
]);
